import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SignalSelectionCacher {

  private selectedSignals = [];

  constructor() {}

  public saveSelectedSignals(signalGroups: Array<any>) {
    this.selectedSignals = signalGroups.flatMap(e => e.signals).filter(s => s.checked === true).map(v => v.value);
  }

  public restoreSelectedSignals(signalGroups: Array<any>) {
    signalGroups.forEach((group) => {
      group.signals.forEach(signal => {
        if (this.selectedSignals.indexOf(signal.value) > -1 ) {
          signal.checked = true;
        }
      });
    });
  }

}
